<template>
  <div class="input-group">
    <input
      :id="id"
      v-model="model"
      type="checkbox"
      class="checkbox option-input"
      :disabled="disabled"
    />

    <label class="d-flex" :for="id">
      <span class="mt-1" :style="{ 'background-color': backgroundColor}">
        <em v-if="model" class="ic-check" />
      </span>
      {{ text }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'CustomCheckbox',
  props: {
    text: {
      type: String,
      default: () => '',
    },
    value: {
      type: Boolean,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: 'transparent',
    },
  },
  data() {
    return {
      model: this.value,
      id: Math.random().toString(36),
    };
  },
  watch: {
    model(val) {
      this.$emit('onChange', val);
      this.$emit('input', val);
    },
    value(val) {
      this.model = val;
    },
  },
};
</script>

<style src="@/assets/css/component/checkbox.css" scoped></style>
